import {PROPERTY_SCOPE_NAMES} from '~/assets/js/constants'
import {usePimHelper} from '~/composables/pim_helper'
import {useProductService} from '~/composables/product_service'
import {getPages} from '../config/helper'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name?.toString()?.startsWith('products-product')) {
    const app = useNuxtApp()
    const i18n = app.$i18n
    const productService = useProductService()
    const {loadProductCategoryWithPim} = usePimHelper(i18n)
    const product = to.params.product
    const productData = await productService.getProductBySkuNew(product, app.$globalization.getRegion(), i18n.locale.value, false, null, PROPERTY_SCOPE_NAMES.DESIGN_ONLY)
    if (productData) {
      // Load category data using the new helper (already resolves redirects internally)
      const categoryJson = await loadProductCategoryWithPim(productData?.productDesign, to)
      const parsedCategoryJson = typeof categoryJson === 'string' ? JSON.parse(categoryJson) : categoryJson

      let categoryUrl = null
      let url = ''
      if (parsedCategoryJson?.url) {
        categoryUrl = parsedCategoryJson.url
        url = app.$globalization.localePath(categoryUrl + '/' + i18n?.t('pages.products') + '/' + product)
      } else if (typeof productData?.productDesign === 'string' && productData.productDesign) {
        const pages = getPages() as Record<string, any>
        const currentLocale = i18n.locale.value as string
        let categorie = pages[currentLocale]?.categories || ''
        categoryUrl = categorie + '/' + productData.productDesign
        url = '/' + app.$globalization.getRegion().toLocaleLowerCase() + '/' + i18n.locale.value + '/' + categoryUrl + '/' + i18n?.t('pages.products') + '/' + product
      } else {
        return showError({statusCode: 404})
      }
      return navigateTo(url)
    } else {
      showError({statusCode: 404})
    }
  }
})
